// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"8b7ff862f5c50741","7730":"7109a3c903522345","9292":"7109a3c903522345"}[chunkId] + ".css";
};